import { useOutletContext } from 'react-router-dom';
import { TuiGridTwoColumnStyle } from '../../../assets/styles/TuiGridTwoColumnStyle';
import { Dispatch, SetStateAction, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { SearchOptions } from '../../../assets/styles/SearchOptions';
import Input from '../../../components/Input';
import { BtnBlue, BtnDeep, BtnGhost, BtnGray, BtnRed, BtnWhite } from '../../../components/Button';
import { useRecoilValue } from 'recoil';
import { userState } from '../../../atoms';
import { COMCD_USE_YN, INIT_USE_YN_A, INIT_USE_YN_Y, TTS_LANGUAGES } from '../../../_constants';
import { useFetchCommonCodeList } from '../../../services/useSetCodeListInSelectBoxForm';
import { useTranslation } from 'react-i18next';
import { useSetAuth } from '../../../utils/useSetAuth';
import { useDetectScrolledToBottom } from '../../../utils/useDetectScrolledToBottom';
import { useQuery } from '@tanstack/react-query';
import { apiDelete, apiGet, apiPost } from '../../../services/_common';
import TuiGrid from '../../../components/Table/TuiGrid';
import SelectBox from '../../../components/SelectBox';
import RadioContainer from '../../../components/button/RadioContainer';
import i18n from '../../../translation/i18n';
import Portal from '../../../components/Portal';
import DeleteModal from '../../../components/Modal/DeleteModal2';
import BackButton from '../../../components/BackButton';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import FileUploadButton from '../../../components/button/FileUploadButton';
import { applyBorderStyle } from '../../../utils/applyBorderStyle';
import { ButtonsWrapper } from '../setting7/cctvInfoStyle';
import { trimObject } from '../../../utils/trimObject';
import { logPost } from '../../../services/log';
import { ynFilter } from '../../../utils/ynFilter';
import CustomAudioPlayBtnRenderer from '../../../components/CustomAudioPlayBtnRenderer';
import { InputTable } from '../../../assets/styles/InputTable';
import IssueGuide from '../../../components/IssueGuide';
import Textarea from '../../../components/Textarea';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import audioConcat from '../../../utils/audioConcat';
import tts, { lanCdToTtsType, synthesizeTts } from '../../../utils/tts';
import { TTS_PAUSE_OPTIONS, TTS_SPEAKING_RATE_OPTIONS, findVoiceOption, getDefaultVoiceOption, getVoiceSelectOptions } from '../../../constants/ttsVoices';
import CustomMobileModal from '../../../components/Modal/CustomMobileModal';
import { PulseLoader } from 'react-spinners';
import { LoadingModalBackground } from '../../../assets/styles/Modal';
import { isMobile } from '../../../utils/checkMobile';
import TextInfoBox from '../../../components/TextInfoBox';
import useTuiGridSize from '../../../hooks/useTuiGridSize';
import { WebSDKspeaker } from '../../../utils/webSDKspeakerClass';
import CustomDetectAudioRenderer from '../../../components/CustomDetectEvent';
import { downloadFile } from '../../../utils/flutterBridge';
import { END_CHAIM_AUDIO, START_CHAIM_AUDIO } from '../../../utils/chimeAudio';

const SubRoot = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  overflow: auto;
  justify-content: flex-start;

  .emptyData {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    padding-bottom: 4rem;
    gap: 1rem;
    img {
      width: 24rem;
      /* user-drag: none; */
      -webkit-user-drag: none;
    }
    span {
      color: var(--filled-violet);
    }
  }

  .fx-vertical-center {
    display: flex;
    align-items: center;
  }

  .inputForm {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    width: 100%;
    button {
      height: 2.5rem;
      font-size: 0.75rem;
      flex-shrink: 0;
      padding: 0 0.75rem;
      border-radius: 0.25rem;
    }
    button.gray {
      font-weight: 500;
      color: var(--zinc-200);
    }
    label {
      width: 6rem;
      font-weight: 500;
      flex-shrink: 0;
      font-size: 0.875rem;
      line-height: 1.4;
      white-space: normal;
    }

    // 모바일의 경우 맨 끝에 배치
    .file-btn-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      @media (max-width: 480px) {
        align-items: flex-end;
      }
    }

    .inputForm-group-1280 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1280px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1536px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536.withBtn {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      @media (min-width: 481px) {
        flex-direction: row;
        gap: 1rem;
        align-items: flex-end;
      }
    }
    .inputForm-group-1536.withBtn.inputColumnFour {
      input {
        padding: 0;
      }
    }
    .inputForm-row.labelInInput {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      @media (min-width: 769px) {
        flex-direction: row;
        align-items: center;
      }
    }
    .radio-group-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      & > div {
        justify-content: flex-start;
        padding: 0;
        margin-right: 1.25rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
    .inputForm-row.labelOutInput,
    .inputForm-row.labelInInput > div > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      input {
        flex-shrink: 1;
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 0.5rem;
        &:disabled {
          background-color: var(--tonal);
          color: var(--text-disabled);
        }
      }
      > div.viewOnly {
        height: 2.5rem;
        font-size: 0.875rem;
        color: var(--text-primary);
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        display: flex;
        align-items: center;

        &.disabled {
          color: var(--text-disabled);
        }
      }
      > div {
        flex-grow: 1;
        > div > div > ul {
          height: 2.5rem;
          li {
            display: flex;
            width: 100%;
            max-width: 100%;
            span {
              flex-grow: 1;
              width: 4rem;
            }
          }
        }
      }
    }
    .inputForm-row .flex-format-box,
    .flex-format-box {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      width: 100%;
      .formatBox {
        flex-grow: 1;
        margin-left: 0;
      }
    }

    .flex-format-box .formatBox {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.6rem;
      min-width: 2.5rem;
      height: 2.5rem;
      background-color: var(--tonal);
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      border-left: 1px solid var(--outline);
      color: var(--text-primary);
      font-size: 0.95em;
      margin-left: 0.25rem;

      @media (max-width: 480px) {
        width: 2.5rem;
        min-width: 2rem;
        font-size: 0.85em;
      }
    }
    .inputForm-row .flex-ct {
    }
    .detailInfo-group {
      margin: 1rem 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      @media (min-width: 1536px) {
        grid-template-columns: repeat(3, 1fr);
      }
      .flex-col.detailInfo {
        flex-grow: 1;
        width: 100%;
        div {
          height: 2.5rem;
          color: var(--text-tertiary);
          background-color: var(--tonal);
          border-radius: 0.25rem;
          display: flex;
          align-items: center;
          padding: 0 0.5rem;
          font-size: 0.875rem;
        }
        label {
          width: 100%;
        }
      }
    }
  }
  input {
    :disabled {
      background-color: #eeeeee;
    }
  }
  .required {
    &::after {
      content: '*';
      padding: 0 0.2rem;
      color: red;
    }
  }
  .tableTip {
    position: sticky;
    left: 0;
    right: 0;
    user-select: none;
    display: flex;
    font-size: 0.875rem;
    width: 100%;
    align-items: center;
    padding: 0.4rem 1rem;
    background-color: #fffbeb;
    background-color: var(--tonal-orange);
    color: #d97706;
    gap: 0.5rem;
    .material-symbols-rounded {
      font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
      color: #f59e0b;
    }
  }
  .tableTopHead {
    margin: 0 1rem;
  }
  .dragHeadInfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0.5rem 0;
    color: var(--text-primary);

    .inputForm-row {
      button {
        border-radius: 0.4rem;
        padding: 0 0.5rem;
        height: 2.5rem;
      }
    }

    @media screen and (max-width: 1024px) {
      .inputForm-row {
        display: flex;
        gap: 0.5rem;
      }
    }

    @media screen and (max-width: 760px) {
      & {
        flex-direction: column;
        align-items: flex-start;
      }

      .inputForm-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        gap: 0.5rem;
      }
    }
  }
  .totalTime {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.5rem 1rem;
    color: var(--text-primary);

    > span {
      margin-left: 0.5rem;
      color: var(--selected-primary);
    }
  }
  .tipHeadInfo {
    padding: 1rem;
  }
  .ttsContent {
    align-items: flex-start !important;

    textarea {
      width: calc(100% - 1.6rem);
    }
  }
  .customBtn {
    height: inherit;
    padding: 6px;
    border-radius: 50%;

    .material-symbols-rounded {
      font-variation-settings: 'FILL' 1, 'wght' 400;
      color: var(--selected-primary);
    }
  }

  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    height: fit-content;
    overflow: none;
  }
`;

const DraggableRow = ({ type, el, auth, index, moveRow, tableState, setTableState, onClickRow, selectedKey }: any) => {
  const trRef = useRef(null);
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const newCdArray = tableState.map((elParam: any) => elParam.cdSort);
  const cdSortArray = newCdArray.sort((a: number, b: number) => a - b);

  const onClickDelete = () => {
    const tableArray = [...tableState];
    tableArray.splice(index, 1);
    setTableState(tableArray);
  };

  const [, drop] = useDrop({
    accept: 'ROW',
    hover(item: any, monitor) {
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }
      moveRow(tableState, setTableState, dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: (item, monitor) => {
      const copyArray = [...tableState];
      const newArray = copyArray.map((cpItem, cpIndex) => ({ ...cpItem, cdSort: cdSortArray[cpIndex], editor: userInfo.userId }));
      setTableState(newArray);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'ROW',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(trRef));

  return (
    <div ref={trRef} style={{ opacity: isDragging ? 0 : 1 }} role='presentation'>
      <div className={`tr ${selectedKey && el.tatCd === selectedKey ? 'selected' : ''}`} key={el.bsfNameFormat}>
        <div className='trCol2p5 flex-center tableStickyNo'>{index + 1}</div>
        <div className='trCol4 flex-center'>{el.bsfCd}</div>
        <div className='trCol10 flex-basic tableStickyTitle content-overflow'>{el.bsfNameFormat}</div>
        <div className='trCol10 flex-center'>{el.bsfDuration}</div>
        {auth.deleteAuth && (
          <div className='trCol10 flex-center'>
            <BtnRed onClick={onClickDelete}>{t('제거')}</BtnRed>
          </div>
        )}
      </div>
    </div>
  );
};

const dragRow = (list: any[], setList: Dispatch<SetStateAction<any[]>>, fromIndex: number, toIndex: number) => {
  const updatedData = [...list];
  const [movedItem] = updatedData.splice(fromIndex, 1);
  updatedData.splice(toIndex, 0, movedItem);
  setList(updatedData);
};

const alarmTypeList = [
  { type: 'alarmType', alarmType: '', cdName: '미선택' },
  { type: 'alarmType', alarmType: 'fireAudio', cdName: '화재 알림' },
  { type: 'alarmType', alarmType: 'wanderAudio', cdName: '진입 알림' },
  { type: 'alarmType', alarmType: 'tumbleAudio', cdName: '쓰러짐 알림' },
  // { type: 'alarmType', alarmType: 'helmetAudio', cdName: '안전모 감지' },
];

const BroadcastSoundSetting = () => {
  const userInfo = useRecoilValue(userState);
  const emptyRowState = {
    hCd: userInfo.hCd,
    sCd: userInfo.sCd,
    editor: userInfo.userId,
    bsfCd: '',
    bigo: '',
    useYn: 'Y',
    delYn: 'N',
    bsfFsize: '',
    bsfFtime: '',
    bsfName: '',
    bsfDuration: '',
    audioType: '',
  };
  const [MUSIC_INFO, MUSIC_FILE_CONNECTION, TTS_FILE_CREATE] = [0, 1, 2]; // 음원 정보, 음원 파일 연결, 다국어 TTS 음원 파일 생성
  const INIT_LENGUAGE = { type: 'lanCd', lanCd: 'ko-KR', cdName: '한국어' }; // [다국어 TTS 음원파일 생성] = 언어 선택
  const INIT_IS_SAVE = { isSaveClick1: false, isSaveClick2: false, isSaveClick3: false };
  const { t } = useTranslation();
  const { auth } = useSetAuth(); // 사용자 권한값 훅
  const size = useOutletContext<any>();
  const [viewTable, setViewTable] = useState<boolean>(true);
  const mobile = isMobile();
  const userInfoInputFormRef = useRef<any>(null); // 인풋 폼 ref (테이블 로우를 클릭했을 때 바로 inputForm 으로 스크롤 이동시키기 위한 ref)
  const { isBottom } = useDetectScrolledToBottom(userInfoInputFormRef); // 스크롤이 해당노드의 하단에 근접했는지 여부
  const [searchOptionUseYn, setSearchOptionUseYn] = useState(INIT_USE_YN_A);
  const [searchOption, setSearchOption] = useState({ searchBsfName: '' });
  const componentRef = useRef<HTMLDivElement>(null);
  const { tuiHeight } = useTuiGridSize(componentRef);
  const [columns, setColumns] = useState<any[]>([]);
  const [selectedRowKey, setSelectedRowKey] = useState<any>(null);
  const [isNewAdd, setIsNewAdd] = useState(true); // 신규등록 여부
  const [activeTab, setActiveTab] = useState(MUSIC_INFO); // 하위메뉴의 내부탭 액티브상태값
  const [isSaveClicked, setIsSaveClicked] = useState(INIT_IS_SAVE); // 저장버튼 클릭 여부에 따라 필수입력값 보더색상 처리하기 위한 state 값
  const [rowState, setRowState] = useState<any>(emptyRowState);
  const [useYn, setUseYn] = useState(INIT_USE_YN_Y);
  const [openModal, setOpenModal] = useState<any>({ status: false, type: '', title: '' });
  const { data: useYnComCdListWithAll } = useFetchCommonCodeList(COMCD_USE_YN, true); // 사용여부 공통코드 목록 (전체포함)
  const { data: useYnComCdList } = useFetchCommonCodeList(COMCD_USE_YN, false); // 사용유무 공통코드 목록
  const [checkList, setCheckList] = useState<any[]>([]); // 체크리스트
  const [mobileCheckList, setMobileCheckList] = useState<any[]>([]); // 모바일 모달창 체크리스트
  const [connectAudioList, setConnectAudioList] = useState<any[]>([]); // 파일 연결 리스트
  const [audioObj, setAudioObj] = useState<HTMLAudioElement | null>(null);
  const [lanCd, setLanCd] = useState(INIT_LENGUAGE);
  const [MusicFile, setMusicFile] = useState({ musicFileName: '' });
  const [ttsFile, setTtsFile] = useState<any>({ lanContent: '', ttsMusicName: '' });
  const [ttsSpeakingRate, setTtsSpeakingRate] = useState(TTS_SPEAKING_RATE_OPTIONS[2]);
  const [ttsPauseLevel, setTtsPauseLevel] = useState(TTS_PAUSE_OPTIONS[0]);
  const [ttsVoice, setTtsVoice] = useState(getDefaultVoiceOption('ko-KR'));
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [isUnChkAll, setIsUnChkAll] = useState<boolean>(false); // 특정 이벤트 처리 후 모든 체크박스 비활성화 여부
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  const bsfNameRef = useRef<HTMLInputElement>(null);
  const fileNameRef = useRef<HTMLInputElement>(null);
  const ttsNameRef = useRef<HTMLInputElement>(null);
  const ttsContentRef = useRef<HTMLTextAreaElement>(null);
  const ttsPreviewUrlRef = useRef<string | null>(null);
  const ttsPreviewAudioRef = useRef<HTMLAudioElement | null>(null);
  const audioObjRef = useRef<HTMLAudioElement | null>(null); // Use ref to persist the audio object between renders
  const [speakerObj, setSpeakerObj] = useState<WebSDKspeaker | null>(null);
  const [alarmType, setAlarmType] = useState({ type: 'alarmType', alarmType: '', cdName: '미선택' });

  useEffect(() => {
    const websdkSpeaker = new WebSDKspeaker({ setOpenModal });
    websdkSpeaker?.init();
    setSpeakerObj(websdkSpeaker);
  }, []);

  const {
    data: speakerList,
    isLoading: isLoadingSpeakers,
    isError: isErrorSpeakers,
  } = useQuery(['bs_broadcast_schedule', userInfo], () => apiGet({ path: '/bs', req: { hCd: userInfo.hCd, sCd: userInfo.sCd } }), {
    enabled: !!userInfo.hCd && !!userInfo.sCd && userInfo.sCd !== '00000',
  });

  const Backend = mobile ? TouchBackend : HTML5Backend;

  const {
    data: bsfList,
    isLoading,
    isFetching,
    isError,
  } = useQuery(['bsfList', userInfo], () => fetchData(), {
    enabled: !!userInfo.hCd && !!userInfo.sCd && userInfo.sCd !== '00000',
  });

  const [tableState, setTableState] = useState<any[]>(bsfList || []);
  const [mobileTableState, setMobileTableState] = useState<any[]>(bsfList || []);
  const [initTableState, setInitTableState] = useState<any[]>(bsfList || []);

  // 재생중인 오디오가 있으면 정지
  const stopAudioRef = () => {
    if (audioObjRef.current) {
      audioObjRef.current.pause();
      audioObjRef.current.currentTime = 0; // 재생위치 리셋
    }
  };

  useEffect(() => {
    return () => {
      // 컴포넌트 언마운트 시 오디오 정지
      stopAudioRef();
      if (ttsPreviewAudioRef.current) {
        ttsPreviewAudioRef.current.pause();
        ttsPreviewAudioRef.current = null;
      }
      if (ttsPreviewUrlRef.current) {
        URL.revokeObjectURL(ttsPreviewUrlRef.current);
        ttsPreviewUrlRef.current = null;
      }
    };
  }, []);

  const ttsVoiceOptions = useMemo(() => getVoiceSelectOptions(lanCdToTtsType(lanCd.lanCd)), [lanCd.lanCd]);

  useEffect(() => {
    const lanType = lanCdToTtsType(lanCd.lanCd);
    setTtsVoice(getDefaultVoiceOption(lanType));
  }, [lanCd.lanCd]);

  const resolveSelectedTtsVoice = () => {
    const lanType = lanCdToTtsType(lanCd.lanCd);
    return findVoiceOption(lanType, ttsVoice.voiceId) ?? getDefaultVoiceOption(lanType);
  };

  const stopTtsPreview = () => {
    if (ttsPreviewAudioRef.current) {
      ttsPreviewAudioRef.current.pause();
      ttsPreviewAudioRef.current = null;
    }
    if (ttsPreviewUrlRef.current) {
      URL.revokeObjectURL(ttsPreviewUrlRef.current);
      ttsPreviewUrlRef.current = null;
    }
  };

  const onClickTtsPreview = async () => {
    if (!ttsFile.lanContent?.trim()) {
      ttsContentRef.current?.focus();
      toast.warning(t('내용을 입력하세요'));
      return;
    }

    stopTtsPreview();
    stopAudioRef();
    setIsPreviewLoading(true);

    try {
      const lanType = lanCdToTtsType(lanCd.lanCd);
      const voice = resolveSelectedTtsVoice();
      const blob = await synthesizeTts({
        text: ttsFile.lanContent,
        type: lanType,
        speakingRate: Number(ttsSpeakingRate.speakingRate),
        pauseLevel: ttsPauseLevel.pauseLevel,
        voice: {
          voiceId: voice.voiceId,
          languageCode: voice.languageCode,
          ssmlGender: voice.ssmlGender,
        },
      });
      const url = URL.createObjectURL(blob);
      ttsPreviewUrlRef.current = url;
      const audio = new Audio(url);
      ttsPreviewAudioRef.current = audio;
      audio.onended = stopTtsPreview;
      await audio.play();
    } catch (error) {
      console.error(error);
      toast.error(t('미리듣기에 실패했습니다.'));
      stopTtsPreview();
    } finally {
      setIsPreviewLoading(false);
    }
  };

  // 방송장비 목록 데이터패치 함수
  const fetchData = async () => {
    try {
      const res = await apiGet({ path: '/bs/bsf', req: { hCd: userInfo.hCd, sCd: userInfo.sCd } });
      const result = res.data.data;
      const newArray = result?.map((el: any) => {
        return {
          ...el,
          useYnCdName: el.useYn === 'Y' ? t('사용') : t('미사용'),
          bsfNameFormat: `${el.bsfName}.${el.audioType}`,
          bsfFsizeMb: `${el.bsfFsize}MB`,
          bsfDuration: el.bsfFtime.match(/.{1,2}/g).join(':'),
          format: el.bsfFurl.slice(-3, el.bsfFurl.length),
          detectEvent: el.fireAudioYn === 'Y' ? '화재 알림' : el.wanderAudioYn === 'Y' ? '진입 알림' : el.tumbleAudioYn === 'Y' ? '쓰러짐 알림' : '',
        };
      });
      setTableState(newArray);
      setMobileTableState(newArray);
      setInitTableState(newArray);
      return newArray;
    } catch (error) {
      console.error('error', error);
      throw new Error('error');
    }
  };

  // 시간:분:초 분해
  const parseTime = (timeStr: string) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    return { hours, minutes, seconds };
  };

  // 시간 합산 함수
  const timeReducer = (state: { [key: string]: string }, action: { type: string; payload?: string }) => {
    switch (action.type) {
      case 'ADD_TIME': {
        if (action.payload) {
          const { hours, minutes, seconds } = parseTime(action.payload);
          let newHours = Number(state.hours) + hours;
          let newMinutes = Number(state.minutes) + minutes;
          let newSeconds = Number(state.seconds) + seconds;

          // 초가 60 이상이면 분을 증가시킴
          if (newSeconds >= 60) {
            newMinutes += Math.floor(newSeconds / 60);
            newSeconds %= 60;
          }

          // 분이 60 이상이면 시간을 증가시킴
          if (newMinutes >= 60) {
            newHours += Math.floor(newMinutes / 60);
            newMinutes %= 60;
          }

          return {
            hours: newHours.toString().padStart(2, '0'),
            minutes: newMinutes.toString().padStart(2, '0'),
            seconds: newSeconds.toString().padStart(2, '0'),
          };
        }
        return state;
      }
      case 'RESET': {
        return { hours: '00', minutes: '00', seconds: '00' };
      }
      default: {
        return state;
      }
    }
  };

  const [state, dispatch] = useReducer(timeReducer, { hours: '00', minutes: '00', seconds: '00' }); // 시간 합산

  useEffect(() => {
    dispatch({ type: 'RESET' });
    connectAudioList.forEach((time: any) => dispatch({ type: 'ADD_TIME', payload: time.bsfDuration }));
  }, [connectAudioList]);

  useEffect(() => {
    setTtsFile((prev: any) => ({ ...prev, lanContent: '' }));
  }, [lanCd]);

  useEffect(() => {
    const newMap = tableState.reduce((acc, item, index) => {
      const rowKey = item.rowKey ?? index;
      acc[rowKey] = {
        detectEvent: item.fireAudioYn === 'Y' ? 'fireAudio' : item.wanderAudioYn === 'Y' ? 'wanderAudio' : item.tumbleAudioYn === 'Y' ? 'tumbleAudio' : '',
      };
      return acc;
    }, {});

    setColumns([
      {
        header: t('감지 알림음'),
        name: 'detectEvent',
        align: 'center',
        sortable: true,
        minWidth: 80,
        renderer: {
          type: CustomDetectAudioRenderer,
          options: { data: newMap },
        },
      },
      { header: t('음원명'), name: 'bsfNameFormat', sortable: true, minWidth: 200, renderer: { classNames: ['text_secondary', 'font_semibold'] } },
      { header: t('파일크기'), name: 'bsfFsizeMb', align: 'right', sortable: true, minWidth: 80 },
      { header: t('재생시간'), name: 'bsfDuration', align: 'center', sortable: true, minWidth: 120 },
      { header: t('사용유무'), name: 'useYnCdName', align: 'center', sortable: true, minWidth: 80 },
      {
        header: t('재생'),
        align: 'center',
        name: 'bsfFurl',
        renderer: { type: CustomAudioPlayBtnRenderer, options: { onClickPlayBtn, onClickStopBtn, auth, t } },
        minWidth: 60,
      },
    ]);
  }, [i18n.language, bsfList, audioObj, tableState]);

  const onClickStopBtn = (rKey: number) => {
    if (audioObjRef.current) {
      audioObjRef.current.pause();
      audioObjRef.current.currentTime = 0; // Reset playback
      audioObjRef.current = null; // Clear the reference

      const newTabletState = tableState.map((row: any) => {
        return { ...row, playing: false };
      });
      setTableState(newTabletState);
      setMobileTableState(newTabletState);
    }
  };

  // Assuming audioObj is stored at a higher scope, maybe in React's state if using functional components
  const onClickPlayBtn = (rKey: number) => {
    const targetRow = tableState[rKey];
    if (targetRow) {
      const audioPath = targetRow.bsfFurl;

      stopAudioRef();

      // Create a new Audio object and play it
      const newAudioObj = new Audio(audioPath);
      newAudioObj.crossOrigin = 'anonymous';
      newAudioObj
        .play()
        .then(() => {
          const newTabletState = tableState.map((row: any) => (row.rowKey === rKey ? { ...row, playing: true } : { ...row, playing: false }));
          setTableState(newTabletState);
          setMobileTableState(newTabletState);
          audioObjRef.current = newAudioObj; // Store the new audio object in ref

          const handleAudioEnded = () => {
            onClickStopBtn(rKey);
          };

          newAudioObj.addEventListener('ended', handleAudioEnded);

          // Cleanup function to remove the event listener when the audio changes
          return () => {
            newAudioObj.removeEventListener('ended', handleAudioEnded);
          };
        })
        .catch((e) => {
          console.error('Failed to play audio:', e);
        });
    }
  };

  useEffect(() => {
    applyFilter(initTableState);
    stopAudioRef();
  }, [searchOption.searchBsfName, searchOptionUseYn[COMCD_USE_YN]]);

  const applyFilter = (array: any[]) => {
    // 필터링된 어레이 리턴, 대소문자구분X
    const filteredArray = array.filter((item: any) => item.bsfName?.toLowerCase()?.includes(searchOption.searchBsfName?.toLowerCase()));
    const result = ynFilter(filteredArray, 'useYn', searchOptionUseYn[COMCD_USE_YN]);

    if (result.length > 0) {
      const newState = result.map((el: any, i) => ({ ...el, rowKey: i, sortKey: i, playing: false }));
      setTableState(newState);
      setMobileTableState(newState);
    } else {
      setTableState([]);
      setMobileTableState([]);
    }
  };

  // Row 클릭
  const onClickRow = (rowData: any) => {
    if (rowData) {
      const { rowKey, rowSpanMap, sortKey, uniqueKey, _attributes, _disabledPriority, _relationListItemMap, ...newRowData } = rowData;
      const newOptionData = {
        ...newRowData,
        bsfDuration: newRowData.bsfFtime.match(/.{1,2}/g).join(':'),
      };
      setRowState(newOptionData);
      setSelectedRowKey(rowData.rowKey);
      setIsNewAdd(false);
      setIsSaveClicked(INIT_IS_SAVE);
      setViewTable(false);
      setUseYn({ type: COMCD_USE_YN, [COMCD_USE_YN]: rowData.useYn, cdName: rowData.useYn === 'Y' ? t('사용') : t('미사용') });
      setAlarmType({
        type: 'alarmType',
        alarmType: rowData.fireAudioYn === 'Y' ? 'fireAudio' : rowData.wanderAudioYn === 'Y' ? 'wanderAudio' : rowData.tumbleAudioYn === 'Y' ? 'tumbleAudio' : '',
        cdName: rowData.fireAudioYn === 'Y' ? '화재 알림' : rowData.wanderAudioYn === 'Y' ? '진입 알림' : rowData.tumbleAudioYn === 'Y' ? '쓰러짐 알림' : '미선택',
      });

      // if (rowData.bsCd) getBsDetail(rowData.bsCd);
    }
  };

  const stopAudioIfPlaying = (array: any[]) => {
    const findPlayingAudio = array.find((el) => el.playing);
    if (findPlayingAudio) {
      const newTableState = array.map((el) => (el.playing ? { ...el, playing: false } : el));
      return newTableState;
    }
    return array;
  };

  // 초기화 버튼 클릭. 옵션, 인풋창 초기화
  const onClickInitiateSearchOption = () => {
    setSearchOption({ searchBsfName: '' });
    setSearchOptionUseYn(INIT_USE_YN_A);
    setLanCd(INIT_LENGUAGE);
    onClickNewAdd(); // 우측 인풋창도 초기화
    setSelectedRowKey(null);

    stopAudioRef();
    const newState = stopAudioIfPlaying(tableState);
    setTableState(newState);
    setMobileTableState(newState);
  };

  // 신규등록 버튼 클릭해서 새 입력창(iputForm) 노출
  const onClickNewAdd = () => {
    setIsNewAdd(true);
    initiateState();
    setActiveTab(MUSIC_INFO);
    if (size.innerSize.W <= 1024) setViewTable(false);
  };

  // 스테이트 객체의 밸류를 ''로 초기화
  const initiateState = () => {
    setIsSaveClicked(INIT_IS_SAVE);
    setSelectedRowKey(null);
    setRowState(emptyRowState);
    setUseYn(INIT_USE_YN_Y);
    setAlarmType({ type: 'alarmType', alarmType: '', cdName: t('미선택') });
  };

  const backToMain = () => {
    setViewTable(true);
    setSelectedRowKey(null);
  };

  const deleteAPI = async () => {
    const req = {
      hCd: userInfo.hCd,
      sCd: userInfo.sCd,
      bsfCd: rowState.bsfCd,
      editor: userInfo.userId,
    };
    const res = await apiDelete({ path: '/bs/bsf', req });
    const { statusCode, data } = res.data;
    if (statusCode === 200) {
      const newArray = data?.map((el: any) => ({
        ...el,
        useYnCdName: el.useYn === 'Y' ? t('사용') : t('미사용'),
        bsfNameFormat: `${el.bsfName}.${el.audioType}`,
        bsfFsizeMb: `${el.bsfFsize}MB`,
        bsfDuration: el.bsfFtime.match(/.{1,2}/g).join(':'),
        format: el.bsfFurl.slice(-3, el.bsfFurl.length),
      }));

      applyFilter(newArray);
      setInitTableState(newArray);
      initiateState();
      setSelectedRowKey(null);
      setIsNewAdd(true);

      toast.success(t('방송 장비 음원 삭제 성공'));

      await logPost({
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        userId: userInfo.userId,
        menu: '방송장비 정보',
        action: '삭제',
        etc: `${rowState.bsName}(${rowState.bsCd})`,
      });
    } else if (statusCode === 400) {
      toast.warning(t('스케줄/알림에 사용중인 음원은 삭제하실 수 없습니다.'));
    }
  };

  const onClickDelete = () => {
    // if (rowState.useCount > 0) {
    //   toast.warning(t('스케줄/알림에 사용중인 음원은 삭제하실 수 없습니다.'));
    // } else {
    // }
    setOpenModal((prev: any) => ({ ...prev, status: true, type: 'delete', api: () => deleteAPI() }));
  };

  const onClickAddAudio = () => {
    setOpenModal((prev: any) => ({ ...prev, status: true, type: 'audioAddList' }));
  };

  const onClickSave = async (activeTabParam: number) => {
    if (activeTabParam === 0) {
      // 음원 설정 탭인 경우
      const newRowState = {
        hCd: userInfo.hCd,
        sCd: userInfo.sCd,
        editor: userInfo.userId,
        useYn: useYn[COMCD_USE_YN],
        bsfName: rowState.bsfName,
        bsfFsize: rowState.bsfFsize,
        bsfFtime: rowState.bsfFtime,
        bigo: rowState.bigo,
        file: rowState.file,
        bsfCd: rowState.bsfCd,
        fireAudioYn: alarmType.alarmType === 'fireAudio' ? 'Y' : 'N',
        wanderAudioYn: alarmType.alarmType === 'wanderAudio' ? 'Y' : 'N',
        tumbleAudioYn: alarmType.alarmType === 'tumbleAudio' ? 'Y' : 'N',
        // helmetAudioYn: alarmType.alarmType === 'helmetAudio' ? 'Y' : 'N',
      };

      if (isNewAdd) {
        // 신규등록은 코드 키 제외
        delete newRowState.bsfCd;
      }
      if (newRowState.file === undefined) {
        // 수정에서 file을 넣지 않았을때는 file키 제외
        delete newRowState.file;
      }

      const req = trimObject(newRowState);
      setIsSaveClicked((prev) => ({ ...prev, isSaveClick1: true }));
      if (!req.bsfName) {
        bsfNameRef.current?.focus();
        return toast.warning(t('음원명을 입력하세요'));
      }

      setIsDownloadLoading(true);
      return postAPI(req);
    }
    if (activeTabParam === 1) {
      const files = connectAudioList.map((item: any) => {
        const file = item.bsfFurl;
        return file;
      });

      setIsSaveClicked((prev) => ({ ...prev, isSaveClick2: true }));
      if (!MusicFile.musicFileName) {
        fileNameRef.current?.focus();
        return toast.warning(t('음원명을 입력하세요'));
      }
      if (connectAudioList.length === 0 || connectAudioList.length === 1) {
        return toast.warning(t('음원 파일을 추가하세요'));
      }

      setIsDownloadLoading(true);

      try {
        await audioConcat(files, MusicFile.musicFileName);
      } catch (error) {
        console.error(error);
        toast.error(t('음원 파일 연결에 실패했습니다.'));
      } finally {
        setIsDownloadLoading(false);
      }

      return false;
    }
    if (activeTabParam === 2) {
      setIsSaveClicked((prev) => ({ ...prev, isSaveClick3: true }));
      if (!ttsFile.ttsMusicName) {
        ttsNameRef.current?.focus();
        return toast.warning(t('음원명을 입력하세요'));
      }

      if (!ttsFile.lanContent) {
        ttsContentRef.current?.focus();
        return toast.warning(t('내용을 입력하세요'));
      }

      const lanType = lanCdToTtsType(lanCd.lanCd);
      const voice = resolveSelectedTtsVoice();

      setIsDownloadLoading(true);
      stopTtsPreview();

      try {
        await tts({
          text: ttsFile.lanContent,
          type: lanType,
          fileName: ttsFile.ttsMusicName,
          speakingRate: Number(ttsSpeakingRate.speakingRate),
          pauseLevel: ttsPauseLevel.pauseLevel,
          voice: {
            voiceId: voice.voiceId,
            languageCode: voice.languageCode,
            ssmlGender: voice.ssmlGender,
          },
        });
      } catch (error) {
        console.error(error);
        toast.error(t('음원 생성에 실패했습니다.'));
      } finally {
        setIsDownloadLoading(false);
      }

      return null;
    }
    return null;
  };

  const postAPI = async (reqParam: any) => {
    const res = await apiPost({ path: '/bs/bsf', contentType: 'multipart/form-data', req: reqParam });
    const { data, statusCode, message } = res.data;
    if (statusCode === 200) {
      const newArray = data?.map((el: any) => {
        return {
          ...el,
          useYnCdName: el.useYn === 'Y' ? t('사용') : t('미사용'),
          bsfNameFormat: `${el.bsfName}.${el.audioType}`,
          bsfFsizeMb: `${el.bsfFsize}MB`,
          bsfDuration: el.bsfFtime.match(/.{1,2}/g).join(':'),
          format: el.bsfFurl.slice(-3, el.bsfFurl.length),
        };
      });

      if (reqParam.bsfCd) {
        // 기존데이터 수정 시 해당객체 찾아서 rowState에 업데이트
        const find = newArray.find((el: any) => el.bsfCd === reqParam.bsfCd);
        setRowState(find);
      } else {
        // 신규데이터 저장 시 해당객체 rowState에 업데이트
        setRowState(newArray[data.length - 1]);
        setSelectedRowKey(tableState.length);
        setIsNewAdd(false);

        // // 현장에 등록된 모든 장비에 음원 저장
        // const lastInsertedData = data[data.length - 1]; // 방금 추가한 음원데이터
        // if (speakerList) insertNewAudioIntoAllSpeakers(lastInsertedData);
      }

      setIsDownloadLoading(false);
      applyFilter(newArray);
      setInitTableState(newArray);
      toast.success(t(message));
    } else {
      toast.error(t('오류가 발생했습니다.'));
      setIsDownloadLoading(false);
    }
  };

  const insertNewAudioIntoAllSpeakers = async (lastInsertedData: any) => {
    const newBsInfos: any[] = [];
    // 장비 연결 체크
    await Promise.allSettled(
      speakerList?.data.data.map(async (bsInfo: any) => {
        await speakerObj
          ?.reqConnCheck({ ip: bsInfo.bsIp, port: bsInfo.pPort, id: bsInfo.bsId, pwd: bsInfo.bsPwd })
          .then(() => {
            newBsInfos.push({ ...bsInfo, isConnFail: false, connectValue: 1, checked: false });
          })
          .catch(() => {});
      })
    );

    // 현장의 모든 장비에 오디오 파일 전송
    await Promise.all(
      newBsInfos.map(async (sp) => {
        try {
          await speakerObj?.reqPostAudioFileAPI({
            ip: sp.bsIp,
            port: sp.pPort,
            id: sp.bsId,
            pwd: sp.bsPwd,
            bsfCd: lastInsertedData.bsfCd,
            bsfFurl: lastInsertedData.bsfFurl,
          });
        } catch (error) {
          console.error('오디오 파일 전송 실패:', error);
        }
      })
    );
  };

  const onCLickCheckBox = (row: any) => {
    // console.log('row : ', row);
    setCheckList(row);
    setIsUnChkAll(false);
  };

  // 모바일 모달 음원파일 체크박스
  const onCLickMobileCheckBox = (row: any) => {
    // console.log('row m : ', row);
    setMobileCheckList(row);
    setIsUnChkAll(false);
  };

  const audioData = (e: any, activeTabParam: number, set: any) => {
    const { files } = e.target;

    const audio = new Audio();

    const maxSize = 20;
    const currentSize = Math.round(((files[0]?.size || 0) / 1024 / 1024) * 10) / 10;

    const nLastIdx = files[0]?.name.lastIndexOf('.');
    const fName = files[0]?.name.slice(0, nLastIdx);
    const format = files[0]?.name.slice(nLastIdx + 1);

    if (maxSize < currentSize) {
      toast.error(t('20MB 이상인 오디오 파일은 업로드 할 수 없습니다'));
      return false;
    }

    // 파일명 50자 이상 초과 방지
    if (fName.length > 50) {
      toast.error(t('오디오 파일명은 50자 이하로 입력해주세요'));
      return false;
    }

    // 확장자에 외국어 있을 경우 확장자 깨짐 방지
    if (!['mp3', 'wav'].includes(files[0]?.name.split('.').pop().toLowerCase().trim() || '')) {
      toast.error(t('오디오 파일 확장자는 mp3, wav만 업로드 할 수 있습니다'));
      return false;
    }

    audio.src = URL.createObjectURL(files[0]);
    audio.onloadeddata = () => {
      const hour = Math.floor(audio.duration / 60 / 60)
        .toString()
        .padStart(2, '0');
      const minute = Math.floor(audio.duration / 60)
        .toString()
        .padStart(2, '0');
      const second = Math.round(audio.duration % 60)
        .toString()
        .padStart(2, '0');
      const totalTime = `${hour}${minute}${second}`;

      const newData = {
        bsfFsize: currentSize.toString(),
        bsfName: fName,
        format,
        bsfFtime: totalTime,
        bsfDuration: `${hour}:${minute}:${second}`,
        file: files[0],
      };
      if (activeTabParam === 0) set((prev: any) => ({ ...prev, ...newData }));
      if (activeTabParam === 1) {
        const fileOption = {
          bsfCd: '-',
          bsfNameFormat: files[0].name,
          bsfFurl: files[0],
        };
        set((prev: any) => [...prev, { ...newData, ...fileOption }]);
      }

      e.target.value = ''; // 파일 필드 초기화
    };

    return false;
  };

  // 파일 업로드
  const onChangeMusicFile = (e: any, activeTabParam: number) => {
    if (activeTabParam === 0) {
      audioData(e, activeTabParam, setRowState);
      return false;
    }
    if (activeTabParam === 1) {
      const duplication = connectAudioList.filter((item) => item.bsfNameFormat === e.target.files[0].name);

      if (connectAudioList.length === 10) {
        e.target.value = ''; // 파일 필드 초기화
        toast.warn(t('연결할 수 있는 음원 파일 갯수는 최대 10개 입니다'));
        return false;
      }
      if (duplication.length > 0) {
        e.target.value = ''; // 파일 필드 초기화
        toast.warn(t('이미 불러온 파일입니다'));
        return false;
      }

      audioData(e, activeTabParam, setConnectAudioList);
      return false;
    }

    return false;
  };

  // 정적 자산은 파일명에 내용 해시가 붙어 캐시가 자동으로 무효화되므로 별도 캐시 버스터가 필요 없다
  const onClickDownload = (param: string) => {
    switch (param) {
      case 'start':
        downloadFile(START_CHAIM_AUDIO, 'start.mp3');
        break;
      case 'end':
        downloadFile(END_CHAIM_AUDIO, 'end.mp3');
        break;
      default:
        break;
    }
  };

  const onClickMove = (viewType: 'pc' | 'mobile') => {
    if (viewType === 'mobile') {
      const nonDuplicatedCheckList = mobileCheckList.filter((check) => !connectAudioList.find((connectAudio) => check.bsfCd === connectAudio.bsfCd));

      // console.log('checkList m : ', checkList);

      if (mobileCheckList.length === 0) {
        toast.warn(t('연결할 음원 파일을 선택하세요'));
      } else if (nonDuplicatedCheckList.length === 0) {
        toast.warn(t('이미 이동된 파일입니다'));
      } else if (nonDuplicatedCheckList.length + connectAudioList.length > 10) {
        toast.warn(t('연결할 수 있는 음원 파일 갯수는 최대 10개 입니다'));
      } else {
        setConnectAudioList((prev) => [...prev, ...nonDuplicatedCheckList]);
        onClickClose();
      }

      setIsUnChkAll(true);
    } else if (viewType === 'pc') {
      const nonDuplicatedCheckList = checkList.filter((check) => !connectAudioList.find((connectAudio) => check.bsfCd === connectAudio.bsfCd));

      if (checkList.length === 0) {
        toast.warn(t('연결할 음원 파일을 선택하세요'));
      } else if (nonDuplicatedCheckList.length === 0) {
        toast.warn(t('이미 이동된 파일입니다'));
      } else if (nonDuplicatedCheckList.length + connectAudioList.length > 10) {
        toast.warn(t('연결할 수 있는 음원 파일 갯수는 최대 10개 입니다'));
      } else {
        setConnectAudioList((prev) => [...prev, ...nonDuplicatedCheckList]);
        setIsUnChkAll(true);
        onClickClose();
      }
    }
  };

  const onClickClose = () => {
    setOpenModal((prev: any) => ({ ...prev, status: false }));
  };

  const onClickDownloadRecordFiles = () => {
    if (checkList.length === 0) {
      toast.warn(t('다운로드할 음원 파일을 선택하세요'));
      return false;
    }

    checkList.forEach((item, index) => {
      if (item.bsfFurl) {
        setTimeout(() => {
          const fileName = item.bsfNameFormat;
          handleFileDownload(item.bsfFurl, fileName || 'download.mp3');
        }, index * 1000); // Delay each download by 1 second
      }
    });

    return false;
  };

  const handleFileDownload = async (fileUrl: string, filename: string) => {
    try {
      await downloadFile(fileUrl, filename); // 파일 다운로드가 끝날 때까지 대기
      setIsUnChkAll(true); // 그 후 체크 해제
    } catch (err) {
      console.error('There was an error:', err);
    }
  };

  return (
    <div className={`content-container ${size.innerSize.W > 1024 ? 'twoColumn column-55 max800' : 'oneColumn'}`}>
      <TuiGridTwoColumnStyle className={size.innerSize.W > 1024 || viewTable ? 'showRoot' : 'hideRoot'}>
        <SearchOptions align='left'>
          {size.innerSize.W > 1024 ? (
            <>
              <div className='inputsWrapper'>
                <div className='inputForm-row'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='useYn'>{t('사용유무')}</label>
                    <SelectBox
                      options={useYnComCdListWithAll}
                      defaultOption={searchOptionUseYn.cdName}
                      state={searchOptionUseYn}
                      setState={setSearchOptionUseYn}
                      stateKey={COMCD_USE_YN}
                      initiateKey={searchOptionUseYn[COMCD_USE_YN]}
                    />
                  </div>
                </div>
                <div className='inputForm-row'>
                  <div className='inputForm-col '>
                    <Input placeholder={t('음원명')} label='' type='text' id='searchBsfName' name='searchBsfName' state={searchOption} setState={setSearchOption} />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='secondSearchOption'>
                  <div className='flex-basic textBtnGroup'>
                    <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                  </div>
                  <div className='flex-basic iconBtnGroup'>
                    {activeTab === MUSIC_FILE_CONNECTION && (
                      <BtnGhost onClick={() => onClickMove('pc')}>
                        <span className='material-symbols-rounded'>arrow_forward</span>
                        {t('선택 이동')}
                      </BtnGhost>
                    )}
                    <BtnGhost onClick={onClickDownloadRecordFiles}>
                      <span className='material-symbols-rounded'>download </span>
                      {t('파일 다운로드')}
                    </BtnGhost>
                    <BtnGhost onClick={onClickNewAdd}>
                      <span className='material-symbols-rounded'>add</span>
                      {t('등록')}
                    </BtnGhost>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className='filter-wrapper'>
              <div className='inputsWrapper'>
                <div className='inputForm-row' style={{ width: '100%' }}>
                  <div className='inputForm-col'>
                    <Input placeholder={t('음원명')} label='' type='text' id='searchBsfName' name='searchBsfName' state={searchOption} setState={setSearchOption} ico='search' />
                  </div>
                </div>
              </div>
              <div className='inputsWrapper'>
                <div className='flex-basic iconBtnGroup'>
                  {activeTab === MUSIC_FILE_CONNECTION && (
                    <BtnGhost onClick={() => onClickMove('pc')}>
                      <span className='material-symbols-rounded'>arrow_forward</span>
                      {t('선택 이동')}
                    </BtnGhost>
                  )}
                  <BtnGhost onClick={onClickDownloadRecordFiles}>
                    <span className='material-symbols-rounded'>download </span>
                    {t('파일 다운로드')}
                  </BtnGhost>
                  <BtnGhost onClick={onClickNewAdd}>
                    <span className='material-symbols-rounded'>add</span>
                    {t('등록')}
                  </BtnGhost>
                </div>
              </div>
            </div>
          )}
        </SearchOptions>
        <div ref={componentRef} className='tui-container'>
          <TuiGrid
            data={tableState}
            columns={columns}
            perPage={15}
            rowKey={selectedRowKey}
            onClickRow={onClickRow}
            frozenCount={size.innerSize.W > 1024 ? 1 : 0}
            height={tuiHeight}
            onClickCheckBox={onCLickCheckBox}
            isUnChkAll={isUnChkAll}
          />
        </div>
      </TuiGridTwoColumnStyle>
      {(size.innerSize.W > 1024 || !viewTable) && (
        <TuiGridTwoColumnStyle>
          <div className='inputFormsWrapper smallTab'>
            {size.innerSize.W <= 1024 && <BackButton func={() => backToMain()} />}
            <div className='tabMenuGroup'>
              <div className='tabMenuGroupInner'>
                <div className={`tab ${activeTab === MUSIC_INFO ? 'activeTab' : undefined}`} role='button' tabIndex={0} onClick={() => setActiveTab(MUSIC_INFO)}>
                  {t('음원 정보')}
                </div>
                <div className={`tab ${activeTab === MUSIC_FILE_CONNECTION ? 'activeTab' : undefined}`} role='button' tabIndex={0} onClick={() => setActiveTab(MUSIC_FILE_CONNECTION)}>
                  {t('음원 파일 연결')}
                </div>
                <div className={`tab ${activeTab === TTS_FILE_CREATE ? 'activeTab' : undefined}`} role='button' tabIndex={0} onClick={() => setActiveTab(TTS_FILE_CREATE)}>
                  {t('다국어 TTS 음원파일 생성')}
                </div>
              </div>
            </div>
          </div>

          {activeTab === MUSIC_INFO && (
            <SubRoot>
              <div className='inputForm'>
                <div className='inputForm-group-1536'>
                  {!isNewAdd && (
                    <div className='inputForm-row labelOutInput'>
                      <label htmlFor='code'>{t('코드')}</label>
                      <div className='viewOnly'>{rowState.bsfCd}</div>
                    </div>
                  )}
                </div>

                <div className='inputForm-group-1536 withBtn'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='musicFileName'>{t('음원명')}</label>
                    <div className={`flex-format-box ${rowState.audioType === '' ? 'isFile' : ''}`}>
                      <Input
                        className='required'
                        type='text'
                        id='bsfName'
                        name='bsfName'
                        state={rowState}
                        setState={setRowState}
                        disabled={!auth.updateAuth}
                        inputRef={bsfNameRef}
                        getBorderStyle={isSaveClicked.isSaveClick1 ? applyBorderStyle(rowState.bsName, 'red', 'bsName') : undefined}
                      />
                      <div className='formatBox'>
                        <span>{rowState?.audioType ? `.${rowState.audioType}` : ''}</span>
                      </div>
                    </div>
                  </div>
                  <div className='inputForm-row labelInInput file-btn-row'>
                    {rowState.bsfCd === '' && (
                      <FileUploadButton id='music' name='music' label='음원 파일 불러오기' accept='.mp3, .wav' ico='music_note' handleChange={(e) => onChangeMusicFile(e, activeTab)} />
                    )}
                  </div>
                </div>

                <div className='inputForm-group-1536'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='code'>{t('파일크기')}</label>
                    <div className='viewOnly disabled'>
                      {rowState.bsfFsize}
                      {rowState.bsfFsize !== '' && 'MB'}
                    </div>
                  </div>

                  <div className='inputForm-row labelInInput'>
                    <div className='fx-vertical-center'>
                      <small className='red'>( ※ {t('20MB 이상은 불러오기 불가')} )</small>
                    </div>
                  </div>
                </div>
                <div className='inputForm-group-1536'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='code'>{t('재생시간')}</label>
                    <div className='viewOnly disabled'>{rowState.bsfDuration}</div>
                  </div>
                </div>

                <div className='inputForm-group-1536'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='useYn'>{t('사용유무')}</label>
                    <div>
                      <SelectBox options={useYnComCdList} defaultOption={useYn.cdName || t('사용')} state={useYn} setState={setUseYn} stateKey={COMCD_USE_YN} initiateKey={useYn[COMCD_USE_YN]} />
                    </div>
                  </div>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='useYn'>{t('감지 알림 종류')}</label>
                    <div>
                      <SelectBox
                        options={alarmTypeList}
                        defaultOption={alarmType.cdName || t('미선택')}
                        state={alarmType}
                        setState={setAlarmType}
                        stateKey='alarmType'
                        initiateKey={alarmType.alarmType}
                      />
                    </div>
                  </div>
                </div>

                <div className='inputForm-row labelInInput'>
                  <Input label={t('비고')} type='text' id='bigo' name='bigo' state={rowState} setState={setRowState} disabled={!auth.updateAuth} maxLength={100} />
                </div>
                {!isNewAdd ? (
                  <div className='detailInfo-group group-col-2'>
                    <div className='flex-col detailInfo'>
                      <label htmlFor='createDate'>{t('등록일자')}</label>
                      <div>{rowState.wDate}</div>
                    </div>
                    <div className='flex-col detailInfo'>
                      <label htmlFor='createUser'>{t('등록자')}</label>
                      <div>{rowState.writer}</div>
                    </div>

                    <div className='flex-col detailInfo'>
                      <label htmlFor='updateDate'>{t('수정일자')}</label>
                      <div>{rowState.eDate}</div>
                    </div>
                    <div className='flex-col detailInfo'>
                      <label htmlFor='updateUser'>{t('수정자')}</label>
                      <div>{rowState.editor}</div>
                    </div>
                  </div>
                ) : undefined}
              </div>
            </SubRoot>
          )}

          {activeTab === MUSIC_FILE_CONNECTION && (
            <DndProvider backend={Backend} options={{ enableMouseEvents: true }}>
              <SubRoot>
                <div className='inputForm'>
                  <TextInfoBox ico='info' color='normal' description='여러개의 음원을 1개의 mp3 파일로 연결해 줍니다.' type='fill' />

                  <div className='inputForm-group-1536 withBtn'>
                    <div className='inputForm-row labelOutInput'>
                      <label htmlFor='musicFileName'>{t('음원 파일명')}</label>
                      <div className='flex-format-box'>
                        <Input
                          className='required'
                          type='text'
                          id='musicFileName'
                          name='musicFileName'
                          state={MusicFile}
                          setState={setMusicFile}
                          disabled={!auth.updateAuth}
                          inputRef={fileNameRef}
                          getBorderStyle={isSaveClicked.isSaveClick2 ? applyBorderStyle(MusicFile.musicFileName, 'red', 'bsName') : undefined}
                        />
                        <div className='formatBox'>
                          <span>.mp3</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='tableTopHead'>
                  <TextInfoBox ico='lightbulb' color='orange' description='드래그 앤 드롭을 지원합니다. 행 순서를 위,아래로 변경하세요' type='fill' />
                  <div className='dragHeadInfo'>
                    <div>
                      <span>{t('총 10개 가능')}</span>
                    </div>
                    <div className='inputForm-row labelInInput'>
                      {size.innerSize.W <= 1024 && <BtnDeep onClick={onClickAddAudio}>{t('등록된 음원 불러오기')}</BtnDeep>}
                      <FileUploadButton id='musicFile' name='musicFile' label='음원 파일 불러오기' accept='.mp3, .wav' ico='music_note' handleChange={(e) => onChangeMusicFile(e, activeTab)} />
                    </div>
                  </div>
                </div>
                <InputTable className='margin-left-05'>
                  <div className='thead'>
                    <div className='tr'>
                      <div className='trCol2p5 flex-center tableStickyNo'>No</div>
                      <div className='trCol4 flex-center'>{t('코드')}</div>
                      <div className='trCol10 flex-center tableStickyTitle content-overflow'>{t('음원 명')}</div>
                      <div className='trCol10 flex-center'>{t('재생시간')}</div>
                      {auth.deleteAuth && <div className='trCol10 flex-center'> </div>}
                    </div>
                  </div>
                  {connectAudioList.length > 0 ? (
                    <div className='table'>
                      <div className='tbody'>
                        {connectAudioList.map((el, i) => (
                          <DraggableRow type='bsfList' key={el.bsfName} index={i} el={el} auth={auth} moveRow={dragRow} tableState={connectAudioList} setTableState={setConnectAudioList} />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div style={{ position: 'sticky', left: 0, height: '100%' }}>
                      <IssueGuide />
                    </div>
                  )}
                </InputTable>
                <div className='totalTime'>
                  {t('총 예상 시간')} : <span> {`${state.hours}:${state.minutes}:${state.seconds}`}</span>
                </div>
              </SubRoot>
            </DndProvider>
          )}

          {activeTab === TTS_FILE_CREATE && (
            <SubRoot>
              <div className='tipHeadInfo'>
                <TextInfoBox
                  ico='lightbulb'
                  color='orange'
                  description='음원 파일 생성할 언어를 선택하시고 해당 언어와 음원 파일명을 입력하신 후에 음원 생성 버튼을 클릭하시면 음원 파일이 자동 다운로드 됩니다.'
                  type='fill'
                />
              </div>

              <div className='inputForm'>
                <div className='inputForm-group-1536'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='lanCd'>{t('언어선택')}</label>
                    <SelectBox options={TTS_LANGUAGES} defaultOption={lanCd.cdName} state={lanCd} setState={setLanCd} stateKey='lanCd' initiateKey={lanCd.lanCd} />
                  </div>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='ttsVoice'>{t('목소리')}</label>
                    <div className='radio-group-row'>
                      {ttsVoiceOptions.map((voice) => (
                        <RadioContainer
                          key={voice.voiceId}
                          name={voice.ssmlGender === 'MALE' ? t('남성') : t('여성')}
                          isSelected={ttsVoice.voiceId === voice.voiceId}
                          onClick={() => setTtsVoice(voice)}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div className='inputForm-group-1536'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='speakingRate'>{t('읽기 속도')}</label>
                    <SelectBox
                      options={TTS_SPEAKING_RATE_OPTIONS}
                      defaultOption={ttsSpeakingRate.cdName}
                      state={ttsSpeakingRate}
                      setState={setTtsSpeakingRate}
                      stateKey='speakingRate'
                      initiateKey={ttsSpeakingRate.speakingRate}
                    />
                  </div>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='pauseLevel'>{t('띄어쓰기·쉼')}</label>
                    <SelectBox
                      options={TTS_PAUSE_OPTIONS}
                      defaultOption={ttsPauseLevel.cdName}
                      state={ttsPauseLevel}
                      setState={setTtsPauseLevel}
                      stateKey='pauseLevel'
                      initiateKey={ttsPauseLevel.pauseLevel}
                    />
                  </div>
                </div>
                <div className='inputForm-row labelOutInput ttsContent'>
                  <label htmlFor='code' className='required'>
                    {t('내용 입력')}
                  </label>
                  <Textarea
                    name='lanContent'
                    state={ttsFile}
                    set={setTtsFile}
                    inputRef={ttsContentRef}
                    placeholder={t(`${lanCd.cdName} 입력`)}
                    display='block'
                    flexDirection='row'
                    getBorderStyle={isSaveClicked.isSaveClick3 ? applyBorderStyle(ttsFile.lanContent, 'red', 'bsfName') : undefined}
                  />
                </div>
                <div className='inputForm-group-1536 withBtn'>
                  <div className='inputForm-row labelOutInput'>
                    <label htmlFor='musicFileName'>{t('음원명')}</label>
                    <div className={`flex-format-box ${rowState.format === '' ? 'isFile' : ''}`}>
                      <Input
                        className='required'
                        type='text'
                        id='ttsMusicName'
                        name='ttsMusicName'
                        state={ttsFile}
                        setState={setTtsFile}
                        disabled={!auth.updateAuth}
                        inputRef={ttsNameRef}
                        getBorderStyle={isSaveClicked.isSaveClick3 ? applyBorderStyle(ttsFile.ttsMusicName, 'red', 'bsfName') : undefined}
                        // getBorderStyle={isSaveClicked ? applyBorderStyle(state.userId, 'red', 'userId') : undefined}
                      />
                      <div className='formatBox'>
                        <span>.mp3</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SubRoot>
          )}
          <ButtonsWrapper style={{ justifyContent: 'space-between' }}>
            <div className='flex-between iconBtnGroup'>
              {!isMobile() && (
                <>
                  <BtnGhost onClick={() => onClickDownload('start')}>
                    <span className='material-symbols-rounded'>download </span>
                    {t('시작음 다운로드')}
                  </BtnGhost>

                  <BtnGhost onClick={() => onClickDownload('end')}>
                    <span className='material-symbols-rounded'>download </span>
                    {t('종료음 다운로드')}
                  </BtnGhost>
                </>
              )}
            </div>

            <div className='flex-between'>
              {activeTab === MUSIC_INFO && !isNewAdd && auth.deleteAuth && <BtnRed onClick={onClickDelete}>{t('삭제')}</BtnRed>}
              <div className='flex-between' style={{ gap: '0.5rem' }}>
                {activeTab === TTS_FILE_CREATE && (auth.createAuth || auth.updateAuth) && (
                  <BtnGhost onClick={onClickTtsPreview} disabled={isPreviewLoading || isDownloadLoading}>
                    <span className='material-symbols-rounded'>play_circle</span>
                    {isPreviewLoading ? t('재생 중...') : t('미리듣기')}
                  </BtnGhost>
                )}
                {(auth.createAuth || auth.updateAuth) && <BtnBlue onClick={() => onClickSave(activeTab)}>{activeTab !== TTS_FILE_CREATE ? t('저장') : t('음원 생성')}</BtnBlue>}
              </div>
            </div>
          </ButtonsWrapper>
          {(isDownloadLoading || isPreviewLoading) && (
            <LoadingModalBackground style={{ backgroundColor: 'rgba(0, 0, 0, 0.15)', backdropFilter: 'blur(0.2rem)' }}>
              <PulseLoader className='flex-center' color='rgb(0, 122, 255)' size='1rem' />
            </LoadingModalBackground>
          )}
        </TuiGridTwoColumnStyle>
      )}
      <Portal openModal={openModal?.status}>
        {openModal.type === 'delete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}
        {openModal.type === 'audioAddList' && (
          <CustomMobileModal openModal={openModal} setOpenModal={setOpenModal} title={t('등록된 음원 불러오기')}>
            <div className='body'>
              <TuiGridTwoColumnStyle>
                <div ref={componentRef} className='tui-container'>
                  <TuiGrid data={mobileTableState} columns={columns} perPage={500} frozenCount={1} onClickCheckBox={onCLickMobileCheckBox} />
                </div>
              </TuiGridTwoColumnStyle>
            </div>

            <div className='footer'>
              <BtnGray onClick={onClickClose}>{t('닫기')}</BtnGray>
              <BtnBlue onClick={() => onClickMove('mobile')}>{t('전송')}</BtnBlue>
            </div>
          </CustomMobileModal>
        )}
      </Portal>
    </div>
  );
};

export default BroadcastSoundSetting;
